import { render, staticRenderFns } from "./registerVideoXcx.vue?vue&type=template&id=037b0b87&scoped=true"
import script from "./registerVideoXcx.vue?vue&type=script&lang=js"
export * from "./registerVideoXcx.vue?vue&type=script&lang=js"
import style0 from "./registerVideoXcx.vue?vue&type=style&index=0&id=037b0b87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037b0b87",
  null
  
)

export default component.exports